<template>
  <!-- 客户招新报表 -->
  <div>
    <el-tabs v-model="activeName">
      <el-tab-pane
        label="客户概括"
        name="customer"
      />
      <el-tab-pane
        label="按导购统计"
        name="guide"
      />
      <el-tab-pane
        label="按门店统计"
        name="store"
      />
    </el-tabs>
    <template v-if="activeName === 'customer'">
      <customer-data />
    </template>
    <template v-if="activeName === 'guide'">
      <guide-data />
    </template>
    <template v-if="activeName === 'store'">
      <store-data />
    </template>
  </div>
</template>

<script>
export default {
  name: 'Recruitlist',
  components: {
    'customer-data': () => import('./comps/customer'),
    'guide-data': () => import('./comps/guide'),
    'store-data': () => import('./comps/store')
  },
  data () {
    return {
      loading: false, //列表的加载
      activeName: 'customer', //当前tab选中
      activeNameText: '导购' //选中的tab的名称
    }
  },
  computed: {},
  mounted () {},
  methods: {}
}
</script>

<style lang="scss" scoped>
.top-tips {
  padding: 10px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .top-left {
    display: flex;
    .left-item {
      margin-right: 30px;
    }
  }
  .top-search {
    > div {
      margin-right: 6px;
    }
  }
}
.count {
  font-size: 26px;
  padding-right: 5px;
}

.exportbtn {
  margin-left: 6px;
}
.guide-name {
  padding-left: 38px;
  .guide-pic {
    position: absolute;
    left: 0;
    top: 9px;
  }
  .guide-icon {
    position: absolute;
    left: 0;
    top: 17px;
    margin: auto;
    .iconfont {
      font-size: 34px;
      color: #ccc;
      margin-right: 6px;
    }
  }
}
</style>
